import {useState} from "react";
import {useTranslation} from "react-i18next";
import {FiBookOpen, FiChevronDown, FiChevronUp} from "react-icons/fi";
import QuestionContent from "../QuestionContent/QuestionContent";
import styles from "./QuestionExplanation.module.css";

/**
 * Collapsible text explanation for a question. Renders nothing when empty.
 * The body is rendered through QuestionContent so markdown / code / LaTeX
 * (which the AI may produce) display consistently with question text.
 */
const QuestionExplanation = ({explanation}) => {
    const {t} = useTranslation();
    const [open, setOpen] = useState(false);

    if (!explanation || !explanation.trim()) return null;

    return (
        <div className={styles.wrap}>
            <button type="button" className={styles.toggle} onClick={() => setOpen((o) => !o)}>
                <FiBookOpen size={16} className={styles.icon}/>
                <span className={styles.label}>{t("pages.questionForm.explanationSectionTitle")}</span>
                {open ? <FiChevronUp size={16}/> : <FiChevronDown size={16}/>}
            </button>
            {open && (
                <div className={styles.body}>
                    <QuestionContent text={explanation}/>
                </div>
            )}
        </div>
    );
};

export default QuestionExplanation;
